// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"01f3912c","187":"d4bd3312","331":"fb5ac662","665":"52937150","712":"dd7573e7","827":"613348ad","991":"db203b4d"}[chunkId] + ".chunk.js";
};